var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66602 2.3335V7.66683L8.66602 5.66683L10.666 7.66683V2.3335",
    stroke: "#07B42D",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 12.5V3.5C3 3.10218 3.16462 2.72064 3.45765 2.43934C3.75067 2.15804 4.1481 2 4.5625 2H12.375C12.5408 2 12.6997 2.06321 12.8169 2.17574C12.9342 2.28826 13 2.44087 13 2.6V13.4C13 13.5591 12.9342 13.7117 12.8169 13.8243C12.6997 13.9368 12.5408 14 12.375 14H4.5625C4.1481 14 3.75067 13.842 3.45765 13.5607C3.16462 13.2794 3 12.8978 3 12.5ZM3 12.5C3 12.1022 3.16462 11.7206 3.45765 11.4393C3.75067 11.158 4.1481 11 4.5625 11H13",
    stroke: "#07B42D",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.aa58e82856cb4a000380bc3d270e11f3.svg";
export { ForwardRef as ReactComponent };